import { createBrowserHistory } from 'history';

const isBrowser = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

const browserHistory = isBrowser ? createBrowserHistory() : null;

export default browserHistory;
